import React, { useState, useEffect } from 'react';
import {
  Paper, Typography, TextField, Button, Snackbar, Alert, Box, Grid, Divider, Avatar, List, ListItem, ListItemIcon, ListItemText
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PublicIcon from '@mui/icons-material/Public';
import DevicesIcon from '@mui/icons-material/Devices';
import { useNavigate } from 'react-router-dom';

export default function MeuPerfil() {
  const [perfil, setPerfil] = useState({});
  const [novaSenha, setNovaSenha] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, mensagem: '', tipo: 'success' });
  const navigate = useNavigate();

  useEffect(() => {
    async function buscarPerfil() {
      try {
        const token = localStorage.getItem('token');

        const resposta = await fetch(`${process.env.REACT_APP_API_URL}/usuario/me`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (resposta.ok) {
          const dados = await resposta.json();
          setPerfil(dados);
        } else {
          throw new Error('Erro ao buscar perfil');
        }
      } catch (error) {
        console.error(error.message);
        setSnackbar({ open: true, mensagem: 'Erro ao buscar perfil.', tipo: 'error' });
      }
    }

    buscarPerfil();
  }, []);

  const handleTrocarSenha = async () => {
    if (!novaSenha) {
      setSnackbar({ open: true, mensagem: 'Informe a nova senha.', tipo: 'warning' });
      return;
    }

    try {
      const token = localStorage.getItem('token');

      const resposta = await fetch(`${process.env.REACT_APP_API_URL}/trocar-senha`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ novaSenha })
      });

      if (resposta.ok) {
        setSnackbar({ open: true, mensagem: 'Senha atualizada! Redirecionando para login...', tipo: 'success' });
        setTimeout(() => {
          localStorage.removeItem('token');
          navigate('/');
        }, 3000); // Espera 3 segundos para o usuário ver a mensagem
      } else {
        throw new Error('Erro ao trocar a senha.');
      }
    } catch (error) {
      console.error(error.message);
      setSnackbar({ open: true, mensagem: 'Erro ao trocar a senha.', tipo: 'error' });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ open: false, mensagem: '', tipo: 'success' });
  };

  const handleVoltarDashboard = () => {
    navigate('/dashboard');
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/');
  };

  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" sx={{ color: '#4B49AC', mb: 4 }}>
        Meu Perfil
      </Typography>

      <Grid container spacing={4}>
        {/* Card Perfil */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 4, borderRadius: 3, boxShadow: 3 }}>
            <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
            <Avatar sx={{ bgcolor: '#ed3237', width: 80, height: 80 }}>
            <PersonIcon fontSize="large" />
              </Avatar>
              <Typography variant="h6" fontWeight="bold" mt={2}>
                {perfil.nome || '-'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {perfil.permissao || 'Usuário'}
              </Typography>
            </Box>

            <Divider sx={{ mb: 3 }} />

            <List>
              <ListItem>
                <ListItemIcon><AccessTimeIcon sx={{ color: '#ed3237' }} /></ListItemIcon>
                <ListItemText
                  primary="Último Login"
                  secondary={perfil.ultimo_login ? new Date(perfil.ultimo_login).toLocaleString() : '-'}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon><PublicIcon sx={{ color: '#ed3237' }} /></ListItemIcon>
                <ListItemText
                  primary="IP Último Acesso"
                  secondary={perfil.ip_ultimo_acesso || '-'}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon><DevicesIcon sx={{ color: '#ed3237' }} /></ListItemIcon>
                <ListItemText
                  primary="Navegador"
                  secondary={perfil.navegador_ultimo_acesso || '-'}
                />
              </ListItem>
            </List>

            <Divider sx={{ mt: 3, mb: 3 }} />

            {/* Botões Voltar e Sair */}
            <Box display="flex" flexDirection="column" gap={2}>
            <Button
    variant="outlined"
    onClick={handleVoltarDashboard}
    sx={{
      borderColor: '#ed3237',
      color: '#ed3237',
      fontWeight: 'bold',
      '&:hover': {
        backgroundColor: '#ed3237',
        color: '#000',
      }
    }}
  >
    Voltar para Dashboard
  </Button>

              <Button
                variant="outlined"
                color="error"
                onClick={handleLogout}
              >
                Sair
              </Button>
            </Box>
          </Paper>
        </Grid>

        {/* Card Trocar Senha */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 4, borderRadius: 3, boxShadow: 3 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Trocar Senha
            </Typography>

            <Box mt={3} display="flex" flexDirection="column" gap={2}>
              <TextField
                label="Nova Senha"
                type="password"
                variant="outlined"
                value={novaSenha}
                onChange={(e) => setNovaSenha(e.target.value)}
                fullWidth
                sx={{
                  mt: 2,
                  "& .MuiInputBase-input": { color: "#000" },
                  "& .MuiInputLabel-root": { color: "#333" },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "#ed3237" },
                    "&:hover fieldset": { borderColor: "#ed3237" },
                    "&.Mui-focused fieldset": { borderColor: "#ed3237" }
                  }
                }}
              />

              <Button
                variant="contained"
                sx={{
                  mt: 2,
                  backgroundColor: '#ed3237',
                  color: 'black',
                  fontWeight: 'bold',
                  '&:hover': {
                    backgroundColor: '#ffa733',
                    color: '#000'
                  }
                }}
                onClick={handleTrocarSenha}
              >
                Atualizar Senha
              </Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.tipo} sx={{ width: '100%' }}>
          {snackbar.mensagem}
        </Alert>
      </Snackbar>
    </Box>
  );
}
